import Swiper, { Navigation } from 'swiper';

const NewJobs = () => {
  const swiper = new Swiper('.js-new-jobs', {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 24,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    navigation: {
      disabledClass: 'slider-nav__button_disabled',
      nextEl: '.js-new-jobs-next',
      prevEl: '.js-new-jobs-prev',
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      }
    },
    on: {
      breakpoint: (instance) => {
        instance.slides.css('width', '');
      }
    }
  });
}

export default NewJobs;
